module.exports = __webpack_public_path__ + "static/media/twitter.75a51f7f.svg";